export default "__VITE_ASSET__DEVfEziU__"